export const INITIAL_AUTH_INFO = {
  errorType: '',
  timerInSeconds: 30,
};

export const MAX_LIMIT_ERROR = {
  VERIFY: 'VERIFY_2FA_MAX_LIMIT_REACHED',
  SEND: 'SEND_OTP_MAX_LIMIT_REACHED',
};

export const INVALID_OTP = 'INVALID_CODE';
